import { connect } from 'react-redux'


export default function withStore(mapStateToProps?:any, mapDispatchToProps?:any) {
  return function (target:any) {
      return <any>connect(mapStateToProps, mapDispatchToProps)(target);
  }
}